import * as Sentry from '@sentry/nextjs'
import { format } from 'date-fns'

export const formatLastUpdated = (timestamp: unknown) => {
  if (!timestamp || typeof timestamp !== 'string') return undefined

  try {
    const date = new Date(timestamp)

    // Validate that we have a valid date
    if (isNaN(date.getTime())) {
      return undefined
    }

    return `Last Updated: ${format(date, 'd MMM yy HH:mm')}`
  } catch (error) {
    Sentry.captureException(error)
    return undefined
  }
}
